import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';

interface Props {
  className?: string;
}

const GeneralInfoFooter: React.FC<Props> = ({ className }) => {
  return (
    <View className={className}>
      <View className="items-center ">
        <Text className="font-normal text-gray-400 text-center text-[12px] ">
          Central de Relacionamento | Grande SP
          <Text className="text-primary-600 font-bold"> 4003 3900 </Text> |
          Demais Localidades
          <Text className="text-primary-600 font-bold ">
            {' '}
            0800 729 3900
          </Text>{' '}
        </Text>
        <Text className="text-gray-400 text-center text-[12px]">
          De segunda a sábado, das 8h às 22h | Domingos e feriados, das 9h às
          20h.
        </Text>
      </View>

      <View className="items-center">
        <Text className="font-bold text-base text-gray-400 text-[12px]">
          Ouvidoria
        </Text>
        <Text className=" text-[12px] text-gray-400 text-center ">
          Ligue de um telefone fixo de qualquer região do Brasil:
          <Text className="text-primary-600 font-bold">
            {' '}
            0800 777 5297{' '}
          </Text>{' '}
        </Text>
        <Text className=" text-gray-400 text-center text-[12px]">
          De segunda à sexta, das 9h às 17h, exceto feriados
        </Text>
        <Text className=" text-gray-400 text-center text-[12px]">
          * É necessário protocolo do primeiro nível para acessar a ouvidoria
        </Text>
      </View>
    </View>
  );
};

export default GeneralInfoFooter;
